<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.3803 8.35556L12 0L8.61972 8.35556L0 9.12593L6.53521 15.1111L4.56338 24L12 19.2593L19.4366 24L17.4648 15.1111L24 9.12593L15.3803 8.35556ZM12 5.333L13.9847 10.2388L19.305 10.714L15.2621 14.4164L16.438 19.716L12 16.8874L7.561 19.716L8.73793 14.4164L4.694 10.714L10.0153 10.2388L12 5.333Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'StarOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
